require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-success-of-pokemon-go-and-what-developers-can-learn-from-it.json") })
        }
      }, "path---blog-the-success-of-pokemon-go-and-what-developers-can-learn-from-it");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-success-of-pokemon-go-and-what-developers-can-learn-from-it!./.cache/json/blog-the-success-of-pokemon-go-and-what-developers-can-learn-from-it.json
// module id = 1137
// module chunks = 231608221292675